export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "loading_indicator_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["créé avec <strong>metaScore</strong>"])},
        "contextmenu_footer_prefix": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["créé avec"])}
      },
      "en": {
        "loading_indicator_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["created with <strong>metaScore</strong>"])},
        "contextmenu_footer_prefix": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["created with"])}
      }
    }
  })
}
